import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"

import FieldConfig from "../../../../fields3/proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import ProjectSession from "../../../../model2/project/project-session";
import {
    CUSTOM_ACCESS_OPTIONS,
    FOLDER_ACCESS_OPTIONS,
    ProjectAccessMode,
    ProjectSystemType,
    WORKSPACE_ACCESS_OPTIONS
} from "../../../../model2/project/types";
import FieldProjectAccessMode_FormElement from "./render/form-element";
import FieldProjectAccessMode_FormElementView from "./render/form-element-view";
import {getTagAccessMode, getTagAccessOptions} from "../../../../model2/tag/access-options"

export default class FieldProjectAccessMode extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Project Access";
        this.typeGroup          = GROUP_INFO

        this.noValueOption      = false;


        this.options            = _.get(config, 'options', [])

        this.classes.PopoverMenu = 'max-w-250'
        this.classes.PopoverMenuScrollContainer = 'max-h-400'

        this.components.PopoverMenuMore = null

        this.renderComponents.formElement       = FieldProjectAccessMode_FormElement
        this.renderComponents.formElementView   = FieldProjectAccessMode_FormElementView
    }

    public _getOption(value:any, project?:ProjectSession):any {

        let options : Option[] = []

        switch (project?.systemType) {

            case ProjectSystemType.FOLDER:
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.VIEW:
            case ProjectSystemType.PAGE:
            case ProjectSystemType.WHITEBOARD:
            case ProjectSystemType.EMBED:
            case ProjectSystemType.LINK:
            case ProjectSystemType.CATEGORY:
            case ProjectSystemType.SECTION:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                options = FOLDER_ACCESS_OPTIONS
                break

            case ProjectSystemType.WORKSPACE:
                options = WORKSPACE_ACCESS_OPTIONS
                break

            case ProjectSystemType.TAG:
                options = getTagAccessOptions(project)
                value   = getTagAccessMode(project.id, value) // stored 1 is shown as shared or private by the users number
                break

            default:
                options = CUSTOM_ACCESS_OPTIONS
                break
        }


        const option : any = _.find(options, (option:Option) => {
            return option.value == value
        })

        return option
    }

    getOptionsForEdit(project:ProjectSession):Option[] {

        if (!project) {
            // strange ... hmmm
            console.log("#49433d85 no model???")
            // model = {}
            return []
        }


        switch (project.systemType) {

            case ProjectSystemType.FOLDER:
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.VIEW:
            case ProjectSystemType.PAGE:
            case ProjectSystemType.WHITEBOARD:
            case ProjectSystemType.EMBED:
            case ProjectSystemType.LINK:
            case ProjectSystemType.CATEGORY:
            case ProjectSystemType.SECTION:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                if (project.isRoot) {
                    return [
                        {
                            label       : "Custom Access",
                            value       : ProjectAccessMode.INHERITANCE_CHILDREN,
                            description : "Access is not inherited; grant users access manually.",
                        }
                    ]
                }

                return FOLDER_ACCESS_OPTIONS

            case ProjectSystemType.WORKSPACE:
                return WORKSPACE_ACCESS_OPTIONS

            case ProjectSystemType.TAG:
                return getTagAccessOptions(project, true)

            default:
                return CUSTOM_ACCESS_OPTIONS
        }

    }


    sortValue(value:any) {
        return value ? value : 0;
    }

}
